<template>
  <v-container class="max-container">
    <v-row class="no-pd flex-row-center">
        <v-col class="no-pd flex-row-center flex-wrap"  cols="12" sm="12" md="12" lg="12" xl="12">      
          <v-col v-for="card in groupCardsHome" :key="card.id" cols="12" sm="12" md="4" lg="4" xl="4">          
            <v-card class="container_vcol__vcardhome" @click="goToCardScreen(card.route)" :disabled="card.title == 'Indique amigos'">
              <v-img class="vcard__img" :src="card.image ? card.image : card.imageDefault " >
                <v-card-text>                
                    <div class="flex-row-center-space-around">
                      <div class="flex-col-start">
                        <v-col class="no-pd">
                          <span class="vcard_vcardtext__title">{{ card.title }}</span>
                        </v-col>
                        <v-col  class="no-pd turn_off_filter">
                          <span class="vcard_vcardtext__description">{{ card.description }}</span>
                        </v-col>
                      </div>                  
                      <v-icon class="turn_off_filter"  color="#FFFFFF">
                        mdi-arrow-right 
                      </v-icon>
                    </div>              
                </v-card-text>
              </v-img>
            </v-card>
          </v-col>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
//Services
import { getMenuBannersById } from "@/app/components/home/service/home.service";

//Store
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Home',
  computed: {
    ...mapGetters('authenticateStore', {
        currentCompany: 'get_currentCompany',
        isLoggedIn: 'isLoggedIn'
      }
    ),
    groupCardsHome() {
      return new Array(
        {
          id: 1,
          title: 'Ofertas para você',
          description: 'Confira descontos exclusivos para você.',
          image: this.listBanners.offersBanner,
          imageDefault: this.imagesDefault.offersBanner,
          route: '/ofertas'
        },
        {
          id: 2,
          title: 'Programa de pontos',
          description: 'Acumule pontos para trocar por vale compras.',
          image: this.listBanners.rankingBanner,
          imageDefault: this.imagesDefault.rankingBanner,
          route: '/pontos'
        },
        {
          id: 5,
          title: 'Jornal de ofertas',
          description: 'Fique por dentro de todas as novidades.',
          image: this.listBanners.flyerBanner,
          imageDefault: this.imagesDefault.flyerBanner,
          route: '/jornal'
        },
        // {
        //   id: 6,
        //   title: 'Prêmios',
        //   description: 'Veja os prêmios que te enviamos e faça o resgate.',
        //   image: this.listBanners.prizesBanner,
        //   imageDefault: this.imagesDefault.prizesBanner,
        //   route: '/premios'
        // },
        // {
        //   id: 3,
        //   title: 'Sorteios',
        //   description: 'Participe e ganhe prêmios incríveis.',
        //   image: this.listBanners.raffleBanner,
        //   imageDefault: this.imagesDefault.raffleBanner,
        //   route: '/sorteios' 
        // },
        // {
        //   id: 4,
        //   title: 'Indique amigos',
        //   description: 'Indique amigos e ganhe prêmios.',
        //   image: this.listBanners.inviteBanner,
        //   imageDefault: this.imagesDefault.inviteBanner,
        //   route: '/indiqueAmigos'
        // }
      )
    }
  },
  data: () => ({
    listBanners: {},
    imagesDefault: {
      offersBanner: require('@/assets/img-cards-home/img_ofertas.png'),
      rankingBanner: require('@/assets/img-cards-home/img_ranking.png'),
      raffleBanner: require('@/assets/img-cards-home/img_sorteios.png'),
      inviteBanner: require('@/assets/img-cards-home/img_indique.png'),
      flyerBanner: require('@/assets/img-cards-home/img_jornal.png'),
      prizesBanner: require('@/assets/img-cards-home/img_premios.png')
    }
  }),
  created() {
   this.getBannersList()
  },
  methods: {
    ...mapActions('homeLoaderStore', ['SET_NEWSPAPER_STATE']),
    getBannersList() {
      getMenuBannersById(this.currentCompany.id)
        .then(success => {
            this.listBanners = success.data
            this.SET_NEWSPAPER_STATE(true)
          }
        )
        .catch( error => {
            if (error != null) {
              this.$toasted.show(error.message, { type: 'error' } )
            }
          }
        )
    },
    goToCardScreen(route){
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
@media(max-width: 600px) {
  .vcard_vcardtext__title {
    font-weight: bold;
    font-size: 18px;
    color: var(--cor--branco) !important;
  }
  .vcard_vcardtext__description {
    font-weight: normal;
    font-size: 16px;
    color: var(--cor--branco) !important;
  }
}
.container_vcol__vcardhome {
  min-height: 90px;
  border-radius: 10px !important;
}
.vcard_vcardtext__title {
  font-weight: bold;
  font-size: 18px;
  color: var(--cor--branco) !important;
}
.vcard_vcardtext__description {
  font-weight: normal;
  font-size: 14px;
  color: var(--cor--branco) !important;
}
.btnToScreen {
  height: 24px !important;
  min-width: 24px !important;
  max-width: 24px !important;
}
.vcard__filterDefaut {
  background-color: RGBA(0,0,0,0.75)
}
.vcard__img {
  max-height: 90px;
  min-height: 200%;
}
::v-deep .v-image__image--cover { /*Aqui eu coloco filtro na imagem sem atingir as caracteres*/
  filter: brightness(74%);
  -webkit-filter: brightness(74%);
  -moz-filter: brightness(74%);
}
</style>